import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import InspectorJsonView from './InspectorJsonView'

const useStyles = makeStyles(() => ({
  badge: {
    fontSize: 10,
    padding: '1px 6px',
    borderRadius: 3,
    backgroundColor: 'var(--color-neutral-200)',
    color: 'var(--color-neutral-700)'
  },
  badgeOrion: {
    backgroundColor: 'var(--color-primary-100, #dbeafe)',
    color: 'var(--color-primary-700, #1d4ed8)'
  },
  unresolved: {
    padding: '6px 10px',
    backgroundColor: 'var(--color-warning-050, #fffbeb)',
    border: '1px solid var(--color-warning-200, #fde68a)',
    color: 'var(--color-warning-800, #92400e)',
    fontSize: 11,
    borderRadius: 'var(--border-radius-sm, 4px)'
  },
  skipped: {
    padding: '6px 10px',
    backgroundColor: 'var(--color-neutral-100)',
    color: 'var(--color-neutral-600)',
    fontSize: 11,
    borderRadius: 'var(--border-radius-sm, 4px)'
  }
}))

export default function StepDetails ({ step }) {
  const classes = useStyles()
  const isOrion = step.$op === 'orion/get-reporting-data'
  const orionConnect = step.orionConnect
  const hasOrionBody = orionConnect && !orionConnect.skipped

  const jsonValue = hasOrionBody
    ? { request: step.request, orionConnect: { method: orionConnect.method, urlSuffix: orionConnect.urlSuffix, body: orionConnect.body } }
    : { request: step.request, options: step.options }

  return (
    <div className='flex flex-col flex-1 min-h-0 gap-2'>
      <div className='flex items-center gap-2 flex-shrink-0'>
        <span className={`${classes.badge} font-bold font-mono`}>#{step.index}</span>
        <span className={`${classes.badge} ${isOrion ? classes.badgeOrion : ''} font-bold font-mono`}>{step.$op}</span>
        {step.enabled === false && <span className={`${classes.badge} font-bold font-mono`}>disabled</span>}
      </div>

      {step.unresolvedReferences?.length > 0 && (
        <div className={`${classes.unresolved} font-mono flex-shrink-0`}>
          unresolved: {step.unresolvedReferences.map(r => r.token).join(', ')} — depends on prior step results which are not executed in debug mode
        </div>
      )}

      {orionConnect?.skipped && (
        <div className={`${classes.skipped} font-mono`}>
          orion request not built — reason: {orionConnect.reason}
          {orionConnect.error ? ` (${orionConnect.error})` : ''}
        </div>
      )}

      <InspectorJsonView
        value={jsonValue}
        headerLabel={hasOrionBody ? 'request + orion body' : 'request (after @. substitution)'}
        copyLabel='Copy JSON'
        name={`ddp-inspector-step-${step.index}`}
      />
    </div>
  )
}

StepDetails.propTypes = {
  step: PropTypes.object.isRequired
}
